const marginBottom = '15px';

const style = (theme) => ({
  dashboard: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  dashboard__filtersPanel: {
    marginBottom: marginBottom,
    flexBasis: '5%',
  },

  dashboard__statsRow: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '8px',
    marginBottom: '16px',
    padding: '0 12px',
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },

  cardBlocks__block: {
    flexBasis: '48%',
  },
  stats__block_bottom: {
    display: 'none',
    flexBasis: '100%',
  },
  cardBlocks__block_flex1: {
    flex: 1,
  },
  cardBlocks__block_flex2: {
    flex: 2,
  },

  topCategories: {
    'display': 'flex',
    'align-items': 'center',
    'justifyContent': 'space-between',
    '@media (max-width: 540px)': {
      flexDirection: 'column',
    },
  },
  topCategories__graph: {
    flexBasis: '49%',
  },
  topCategories__table: {
    flexBasis: '49%',
  },
  topBlock__thereIsNotData: {
    padding: '15px 0',
    margin: '0 auto',
    fontSize: '20px',
    width: '200px',
  },
});

export default style;
